const basedataPage = () => import('@/views/main/base/data-page/data-page.vue')
export default {
  path: '/main/shop/shopData',
  name: 'basedataPage',
  component: basedataPage,
  children: []
}
